import { enqueueSnackbar } from "notistack";
import apiClient from "../../api/apiClient";
import {
  clearWorkspaceState,
  fetchWorkspacesFailure,
  fetchWorkspacesStart,
  fetchWorkspacesSuccess,
  persistWorkspaceKey,
  resolveCurrentWorkspace,
  setSelectedWorkspaceKey,
} from "../slices/workspaceSlice";

export const fetchWorkspaces = () => async (dispatch, getState) => {
  dispatch(fetchWorkspacesStart());

  try {
    const { data } = await apiClient.get(
      `${process.env.REACT_APP_BASE_URL}/organizations/mine`,
      { withCredentials: true },
    );

    const organizations = Array.isArray(data?.organizations) ? data.organizations : [];
    dispatch(fetchWorkspacesSuccess(organizations));

    const state = getState();
    const resolvedWorkspace = resolveCurrentWorkspace({
      selectedWorkspaceKey: state.workspace.selectedWorkspaceKey,
      user: state.auth.user,
      organizations,
    });

    dispatch(setSelectedWorkspaceKey(resolvedWorkspace.key));
    persistWorkspaceKey(resolvedWorkspace.key);
  } catch (error) {
    dispatch(
      fetchWorkspacesFailure(
        error?.response?.data?.message || error?.message || "Failed to load workspaces.",
      ),
    );
  }
};

export const selectWorkspace = (workspaceKey) => (dispatch) => {
  const nextKey = workspaceKey || "personal";
  persistWorkspaceKey(nextKey);
  dispatch(setSelectedWorkspaceKey(nextKey));
};

// A link opened from the wrong workspace (an email, a bookmark, a pasted URL): switch to the
// workspace the project belongs to and say so, rather than refusing. The server only names that
// workspace to someone who can open the project there. Returns true when it switched; false if
// already there (so a caller never loops on a refusal the switch cannot fix).
export const switchToOwningWorkspace = (workspace) => (dispatch, getState) => {
  if (!workspace?.key) return false;
  if (getState().workspace.selectedWorkspaceKey === workspace.key) return false;
  dispatch(selectWorkspace(workspace.key));
  const label =
    workspace.type === "organization"
      ? `the ${workspace.name || "organization"} workspace`
      : "your personal workspace";
  enqueueSnackbar(`This project belongs to ${label}, so you have been switched there.`, {
    variant: "info",
    preventDuplicate: true,
  });
  return true;
};

export const resetWorkspaces = () => (dispatch) => {
  persistWorkspaceKey("personal");
  dispatch(clearWorkspaceState());
};